import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import enTranslation from './locales/en.json';
import itTranslation from './locales/it.json';
import deTranslation from './locales/de.json';
import frTranslation from './locales/fr.json';
import jaTranslation from './locales/ja.json';
import koTranslation from './locales/ko.json';
import esTranslation from './locales/es.json';

// Get stored language preference
const getStoredLanguage = () => {
  try {
    const persistedState = localStorage.getItem('language-storage');
    if (persistedState) {
      const { state } = JSON.parse(persistedState);
      if (state && state.language) {
        console.log('i18n init - Found stored language:', state.language);
        return state.language;
      }
    }
  } catch (e) {
    console.error('Error reading language from localStorage:', e);
  }
  
  // Fallback to browser language if no stored preference
  try {
    const browserLang = navigator.language.split('-')[0];
    const supportedLanguages = ['en', 'it', 'de', 'fr', 'ja', 'ko', 'es'];
    const detectedLang = supportedLanguages.includes(browserLang) ? browserLang : 'en';
    console.log('i18n init - Using browser language:', detectedLang);
    return detectedLang;
  } catch (e) {
    console.error('Error detecting browser language:', e);
    return 'en'; // Ultimate fallback
  }
};

// Configure i18next
i18n
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources: {
      en: { translation: enTranslation },
      it: { translation: itTranslation },
      de: { translation: deTranslation },
      fr: { translation: frTranslation },
      ja: { translation: jaTranslation },
      ko: { translation: koTranslation },
      es: { translation: esTranslation }
    },
    lng: getStoredLanguage(), // Directly set language from localStorage or browser
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // React already safes from XSS
    }
  });

// Make sure to set the html lang attribute when language changes
i18n.on('languageChanged', (lng) => {
  document.documentElement.setAttribute('lang', lng);
  console.log('Language changed to:', lng);
});

export default i18n;